// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"profile-menu-m__wrapper__2LFEc"};